import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { DatePipe, DecimalPipe } from '@angular/common';
import 'rxjs/add/observable/of';
import { TripService } from '../../services/trip/trip.service';
import { PdfgeneratorService } from '../../services/pdfgenerator/pdfgenerator.service';
import { ExcelgeneratorService } from '../../services/excelgenerator/excelgenerator.service';
import html2canvas from 'html2canvas';
import { NgxDateRangePickerOptions } from 'src/ngx-daterangepicker';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TripdetailsComponent } from '../trip/tripdetails/tripdetails.component';
import { TokenStorage } from 'src/app/auth/token.storage';
import { MapComponent } from './mapcomponent/map.component';

@Component({
  selector: 'app-tripdetailreport',
  templateUrl: './tripdetailreport.component.html',
  styleUrls: ['./tripdetailreport.component.scss']
})
export class TripdetailreportComponent implements OnInit {
  columnsToDisplay;
  tripDataArray = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  options: NgxDateRangePickerOptions;
  page: number = 0;
  totalRecords: Number;
  excelRecords = [];
  daterRangevalue: any;
  fromDate: any;
  toDate: any;
  isDateFiltered: boolean = false;
  trips = [];
  deptArray = [];
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public dialog: MatDialog,
    public tripService: TripService,
    public generatePdf: PdfgeneratorService,
    public excelService: ExcelgeneratorService,
    public datePipe: DatePipe,
    public decimalPipe: DecimalPipe,
    private token: TokenStorage
  ) { }

  ngOnInit() {
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.columnsToDisplay = [
        'deliveredBy',
        'department',
        'totalVisitsDone',
        'tripName',
        'currentLocation',
        'noOfSamples',
        //'batteryPercentage',
        'distance',
        'tripstate',
        'tripStartDate',
        'tripEndDate',
        'time',
        'lastLocation'
      ];
    }else {
      this.columnsToDisplay = [
        'deliveredBy',
        'department',
        'totalVisitsDone',
        'tripName',
        'tripstate',
        'tripStartDate',
        'tripEndDate',
        'lastLocation'
      ];
    }
    this.createInitialFilter();
  }

  dataForExcel() {
    console.log(this.trips)
    this.excelRecords = [];
   this.trips.forEach(trip => {
      let visitsDone , phoneNo, tripStartedDate, tripEndedDate, dept,deliveredBy,branch,lastDeliveryLocation;

      if (trip.driver_mobile)
        phoneNo = trip.driver_mobile;
      else
        phoneNo = ''

        
      if (trip.trip_warehouse)
      branch = trip.trip_warehouse;
    else
      branch = ''
    
        if (trip.delivered_by)
        deliveredBy = trip.delivered_by;
      else
        deliveredBy = ''

     if (trip.resource_type)
        dept = trip.resource_type;
      else
        dept = '-----'
    
        if (trip.total_number_of_orders)
        visitsDone = trip.total_number_of_orders;
      else
        visitsDone = '-----'

      if (trip.trip_start_time)
        tripStartedDate = this.datePipe.transform(trip.trip_start_time, "medium");
      else
        tripStartedDate = '-----'

      if (trip.trip_end_time)
        tripEndedDate = this.datePipe.transform(trip.trip_end_time, "medium");
      else
        tripEndedDate = '-----'
        if (trip.trip_end_time)
        tripEndedDate = this.datePipe.transform(trip.trip_end_time, "medium");
      else
        tripEndedDate = '-----'

        if (trip.last_Delivery_Address)
        lastDeliveryLocation = trip.last_Delivery_Address;
      else
        lastDeliveryLocation = '';

      if (trip) {
        this.excelRecords.push({
          'Trip Name/Branch': trip.trip_name + branch,
          'Delivered By/Phone No.': deliveredBy + phoneNo,
          'Dept': dept,
          'Visits Done': visitsDone,
          'Started Date/Time': tripStartedDate,
          'Ended Date/Time': tripEndedDate,
          'Trip State':trip.status.slice(11),
          'Last Pickup Address': lastDeliveryLocation,
        });
      }
    }); 
  }

  public captureScreen() {
    var data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
      this.generatePdf.pdfgenerator(canvas, this.tripDataArray.data.length);
    });
  }

  exportAsXLSX(): void {
    this.dataForExcel();
    this.excelService.exportAsExcelFile(this.excelRecords, 'fieldreport');
  }

  ngAfterViewInit() {
    this.tripDataArray.paginator = this.paginator;
  }
  createInitialFilter() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.isDateFiltered = true;
    this.tripFilter();
  }

  tripFilter() {
    this.getData(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(trips => {
      console.log("Trips in report", trips);
      this.tripDataArray.data = trips;
      this.trips = trips;
    })
  }

  applyFilter(filterValue: string) {
    this.tripDataArray.filter = filterValue.trim().toLowerCase();
  }

  getData(from, to) {
    return this.tripService.getTripReport(from, to);
  }

  sortByDate() {
    if (this.daterRangevalue != undefined) {
      this.ngUnsubscribe.next();
      this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
      this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
      this.isDateFiltered = true;
      this.tripFilter();
    }
  }

  clearAllFilter() {
    this.paginator.pageIndex = 0;
    this.createInitialFilter();
    this.isDateFiltered = false;
  }

  tripDetails(tripId) {
    let tripdialog = this.dialog.open(TripdetailsComponent, {
      width: '800px',
      data: {
        component: 'tripreport',
        tripid: tripId,
      }
    });
    tripdialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  openMap(tripName: string) {
    let mapDialog = this.dialog.open(MapComponent, {
      width: '800px',
      data: {
        tripName: tripName,
      }
    });

    mapDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }
}  